const asideNav = () => {
  let iconTrigger = $('.icon-aside__trigger');
  iconTrigger.on('click', function () {

    $(this).parent().toggleClass('is-open');
    $(this).next('.child-list').slideToggle(300);

  });
}
export { asideNav }
